var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bell",
    clipPath: "url(#clip0_334_352)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.6559 9.29685C16.8745 8.05617 16.5913 6.77949 15.8685 5.74765C15.1458 4.71581 14.0428 4.01334 12.8021 3.79477C11.5614 3.5762 10.2847 3.85944 9.2529 4.58217C8.22106 5.30491 7.51859 6.40794 7.30002 7.64861C6.33855 13.1062 3.72487 14.2535 3.72487 14.2535L17.7588 16.7258C17.7588 16.7258 15.6945 14.7545 16.6559 9.29685Z",
    stroke: "#37495F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M11.5414 18.8454C11.3627 19.0575 11.1314 19.219 10.8706 19.3136C10.6099 19.4083 10.3289 19.4328 10.0557 19.3846C9.78252 19.3365 9.52678 19.2175 9.31408 19.0394C9.10138 18.8614 8.93919 18.6306 8.84375 18.3701",
    stroke: "#37495F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_334_352"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19,
    fill: "white",
    transform: "translate(3.7207 0.586914) rotate(9.99127)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.37f7272a1559a78507424fe20f9bfc1e.svg";
export { ForwardRef as ReactComponent };